import React from "react";

export const LazyRoundsPage = React.lazy(() => import("modules/projectRole/pages/RoundsPage"));
